import { parseQueryStatNumber } from "./queryBuilder";
import {
  NAME_SORT_ORDER,
  STAT_SORT_ORDER,
  formatGridStatValue,
  sortedClassFor,
} from "./resultsGrid";

const RATE_FIELDS = new Set([
  "battingAverage",
  "onBasePercentage",
  "sluggingAverage",
  "FLD%",
  "fieldingPercentage",
]);

const ERA_FIELDS = new Set(["era"]);
const DECIMAL_FIELDS = new Set(["rf", "rangeFactor"]);

export const getSeasonStatFormat = (field) => {
  if (field === "year") return "year";
  if (RATE_FIELDS.has(field)) return "rate";
  if (ERA_FIELDS.has(field)) return "era";
  if (DECIMAL_FIELDS.has(field)) return "decimal2";
  return "count";
};

export const getCareerStatFormat = getSeasonStatFormat;

const humanizeStatKey = (key) =>
  key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, " $1");

const toNumericField = (value, field) => {
  if (value == null || value === "") return value;
  if (field === "team" || field === "pos" || field === "position") return value;
  const num = parseQueryStatNumber(value);
  return num == null ? value : num;
};

export const buildSeasonStatRows = (seasons = {}) =>
  Object.entries(seasons)
    .sort((a, b) => Number(b[0]) - Number(a[0]))
    .map(([year, season]) => {
      const row = {
        id: String(year),
        year: Number(year) || year,
        team: season.team,
      };
      Object.entries(season).forEach(([field, value]) => {
        row[field] = toNumericField(value, field);
      });
      return row;
    });

export const buildCareerStatRows = (career = {}) =>
  Object.entries(career)
    .filter(([key]) => !key.startsWith("_"))
    .map(([key, value]) => ({
      id: key,
      statKey: key,
      category: humanizeStatKey(key),
      value: parseQueryStatNumber(value) ?? value,
      format: getCareerStatFormat(key),
    }));

export const enhanceSeasonColumns = (columns = [], sortedField) =>
  columns.map((column) => {
    const isText =
      column.field === "team" || column.field === "pos" || column.field === "position";
    const isYear = column.field === "year";
    const format = getSeasonStatFormat(column.field);
    return {
      ...column,
      type: isText ? undefined : "number",
      align: isText ? column.align : "right",
      headerAlign: isText ? column.headerAlign : "right",
      sortingOrder: isText ? NAME_SORT_ORDER : STAT_SORT_ORDER,
      headerClassName: sortedClassFor(column.field, sortedField),
      cellClassName: sortedClassFor(column.field, sortedField),
      valueFormatter: isYear
        ? ({ value }) => formatGridStatValue(value, format)
        : column.valueFormatter,
      renderCell:
        isText || isYear
          ? column.renderCell
          : (params) => formatGridStatValue(params.value, format),
    };
  });
